export enum AdvanceLeaseAction {
    ReviewApplication = "_Review_Application",
    Approve_Application = "_Approve_Application",
    Approve_Background = "_Approve_Background",
    Complete_MoveIn = "_Complete_MoveIn",
    Send_Offer = "_Send_Offer",
    Validate_Offer = "_Validate_Offer",
    Start_MoveIn = "_Start_MoveIn",
    Start_MoveOut = "_Start_MoveOut",
    Complete_MoveOut = "_Complete_MoveOut"
  }